import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Primary CTA — teal fill, black text (reference AccentButton pattern).
 */
export default function AccentButton({
  children,
  className,
  type = 'button',
  disabled,
  onClick,
  as: Component = 'button',
  ...rest
}) {
  return (
    <Component
      type={Component === 'button' ? type : undefined}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-black text-sm font-medium px-4 py-2 rounded-lg disabled:opacity-50 transition-colors',
        className,
      )}
      {...rest}>
      {children}
    </Component>
  );
}
